import React, { useCallback } from 'react'
import { Box } from '@mui/material'
import { useProtectedHidden } from './visionContext'
import VisionBlurPlaceholder from './VisionBlurPlaceholder'

// The height of a row of the shared table, so a covered row keeps the place of a row in the list (S302).
const ROW_HEIGHT = 33

/**
 * Story 213, reopening 3 (PO 2026-10-23, C15.6, S302, DN-7) — a protected row of a list while the vigilance covers: the
 * blurred placeholder with the height of a row. Like the placeholder, it takes nothing of the row.
 */
export const ProtectedRowPlaceholder = () => (
  <Box sx={{ height: ROW_HEIGHT }}>
    <VisionBlurPlaceholder size='row' />
  </Box>
)

/**
 * `(row) => boolean`: Sun served the row with `sensitive: true` and protected content is hidden now: the vigilance covers
 * (with ALL the whole of MIC, the list included, is unmounted under the overlay anyway), or the session is not watched and
 * the setting says protected content is not shown without vigilance (C16.10).
 */
export const useCoveredProtectedRow = () => {
  const protectedHidden = useProtectedHidden()
  return useCallback((row) => protectedHidden && row.sensitive === true, [protectedHidden])
}

/**
 * `disableSelectAllData` of SmartMateriaUITable (S302, DK-2): while protected content is hidden (covered, or not watched with
 * the setting NO) nothing hidden may get an action, and a paged list cannot tell whether other pages hold protected rows.
 */
export const useVisionCoversSensitive = () => {
  return useProtectedHidden()
}

/** `rowPlaceholder` of SmartMateriaUITable for a list whose whole protected row is covered (products, orders, OF). */
export const useProtectedRowPlaceholder = () => {
  const coveredProtectedRow = useCoveredProtectedRow()
  return useCallback((row) => coveredProtectedRow(row) && <ProtectedRowPlaceholder />, [coveredProtectedRow])
}
